"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Menu = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["onClose", "paperProps", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Menu = function Menu(props) {
  var onClose = props.onClose,
      paperProps = props.paperProps,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(_core.Popper, rest, /*#__PURE__*/_react.default.createElement(_core.Paper, paperProps, /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: onClose
  }, /*#__PURE__*/_react.default.createElement(_core.MenuList, null, children))));
};

exports.Menu = Menu;
Menu.propTypes = {
  /**
   * Conteúdo do menu
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Se TRUE, o componente fica visivel
   */
  open: _propTypes.default.bool,

  /**
   * Valor do conteudo (para casos de uso em select)
   */
  anchorEl: _propTypes.default.instanceOf(Element),

  /**
   * Local que Menu deve aparecer proximo ao elemento anchorEl
   */
  placement: _propTypes.default.string,

  /**
   * Ativa uma função quando usuário clica fora do menu
   */
  onClose: _propTypes.default.func.isRequired,

  /**
   * Props para componente Paper
   */
  paperProps: _propTypes.default.instanceOf(Object)
};
Menu.defaultProps = {
  open: false,
  anchorEl: null,
  placement: 'bottom',
  paperProps: {}
};
var _default = Menu;
exports.default = _default;